import { render } from "./TasksMain.vue?vue&type=template&id=738f727a"
import script from "./TasksMain.vue?vue&type=script&lang=js"
export * from "./TasksMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__